/* eslint-disable import/no-anonymous-default-export */
export default {
  comparison: '产品比较',
  buy: '购买',
  humidity: '湿度',
  air_pressure: '气压',
  moreDetail: '进一步了解 >',
  batteryIcon: '电池图标',
  probeIcon: '外接探头',
  waterproofIcon: '防尘防水',
  supportAppIcon: '支持的 App',
  display_eink: '电子墨水屏',
  display_segment: '低功耗段码屏',
  display_size_50mm: '50 毫米',
  display_size_61x49mm: '61 × 49 毫米',
  display_size_64x44mm: '64.6 × 44.6 毫米',
  display_size_30x19mm: '30 × 19 毫米',
  detection_items: '检测项目',
  comparison_display: '显示屏',
  external_probe: '外接探头',
  dust_proof_waterproof: '防尘防水',
  range: '量程',
  size_weight: '尺寸和重量',
  wireless_communication: '无线通讯',
  supported_apps: '支持的 App',
  remote_monitoring: '远程监测',
  power_and_battery_life: '电源和电池续航',
  placement_and_installation: '摆放和安装方式',
  cp_goose3_display_type: '电子墨水屏',
  cp_goose3_display_size: '50 毫米',
  cp_goose3_range_0_title_0: '温度：0 ~ 50℃',
  cp_goose3_range_1_title_0: '湿度：0 ~ 99.9%RH (无凝露环境)',
  cp_goose3_range_1_note: '* 请勿长时间在湿度超过 90% 的环境下使用。',
  cp_goose3_wireless_desc: '蓝牙',
  cp_goose3_supportApp_0_name: '米家',
  cp_goose3_supportApp_0_note: '* 仅支持米家的中国大陆服务器。',
  cp_goose3_supportApp_1_name: '青萍+',
  cp_goose3_supportApp_2_name: '青萍物联',
  cp_goose3_sizeWeight_0_items_0_label: '70 × 70 × 19 毫米',
  cp_goose3_sizeWeight_0_items_1_label: '48 克（不含支架、电池）',
  cp_goose3_powerInfo_0_label: '7号电池供电',
  cp_goose3_powerInfo_1_label: '续航长达 12 个月',
  cp_goose3_powerInfo_1_note: '* 在常见室温环境下可持续使用 12 个月。实际续航时间可能依环境和电池的差异有所不同。',
  cp_goose3_mounting: '桌面模式、墙面模式、磁吸模式',
  cp_duck3_display_type: '低功耗段码屏',
  cp_duck3_display_size: '50 毫米',
  cp_duck3_range_0_title_0: '温度：-9.9 ~ 50℃',
  cp_duck3_range_1_title_0: '湿度：0 ~ 99.9%RH (无凝露环境)',
  cp_duck3_range_1_note: '* 请勿长时间在湿度超过 90% 的环境下使用。',
  cp_duck3_wireless_desc: '蓝牙',
  cp_duck3_supportApp_0_name: '米家',
  cp_duck3_supportApp_0_note: '* 仅支持米家的中国大陆服务器。',
  cp_duck3_supportApp_1_name: '青萍+',
  cp_duck3_supportApp_2_name: '青萍物联',
  cp_duck3_sizeWeight_0_items_0_label: '70 × 70 × 19 毫米',
  cp_duck3_sizeWeight_0_items_1_label: '55 克（不含支架、电池）',
  cp_duck3_powerInfo_0_label: '7号电池供电',
  cp_duck3_powerInfo_1_label: '续航长达 12 个月',
  cp_duck3_powerInfo_1_note: '* 在常见室温环境下可持续使用 12 个月。实际续航时间可能依环境和电池的差异有所不同。',
  cp_duck3_mounting: '桌面模式、墙面模式、磁吸模式',
  cp_pheasant_s_no_pressure_display_type: '低功耗段码屏',
  cp_pheasant_s_no_pressure_display_size: '61 × 49 毫米',
  cp_pheasant_s_no_pressure_range_0_title_0: '温度：-30 ~ 55℃',
  cp_pheasant_s_no_pressure_range_1_title_0: '湿度：0 ~ 99.9%RH (无凝露环境)',
  cp_pheasant_s_no_pressure_range_1_note: '* 请勿长时间在湿度超过 90% 的环境下使用。',
  cp_frog_range_0_note: '* 请勿长时间在湿度超过 90% 的环境下使用。',
  cp_pheasant_s_no_pressure_range_2_title_0: '气压：30 ~ 125 kPa',
  cp_pheasant_s_no_pressure_wireless_desc: 'Wi-Fi 或 NB-IoT 或 LoRa',
  cp_pheasant_s_no_pressure_supportApp_0_name: '青萍物联',
  cp_pheasant_s_no_pressure_sizeWeight_0_items_0_label: '77 × 77 × 28 毫米',
  cp_pheasant_s_no_pressure_sizeWeight_0_items_1_label: '129 克',
  cp_pheasant_s_no_pressure_powerInfo_0_label: 'USB-C 接口供电\n大容量可充电锂电池',
  cp_pheasant_s_no_pressure_mounting: '墙面模式',
  cp_pheasant_s_display_type: '低功耗段码屏',
  cp_pheasant_s_display_size: '61 × 49 毫米',
  cp_pheasant_s_waterproof_desc: '主机：IP55 级防护\n外接温度探头：IP68 级防护，可持续浸水使用',
  cp_pheasant_s_range_0_title_0: '温度：-20 ~ 50℃',
  cp_pheasant_s_range_0_title_1: '-30 ~ 60℃ (使用锂铁 5 号电池)',
  cp_pheasant_s_range_0_title_2: '-10 ~ 50℃ (使用普通 5 号电池)',
  cp_pheasant_s_range_0_title_3: '0 ~ 40℃ (使用 USB 供电)',
  cp_pheasant_s_range_1_title_0: '主机湿度：',
  cp_pheasant_s_range_1_title_1: '0 ~ 100%RH (使用电池，无凝露环境)',
  cp_pheasant_s_range_1_title_2: '0 ~ 90%RH (使用 USB 供电，无凝露环境)',
  cp_pheasant_s_range_1_title_3: '0 ~ 40℃ (使用 USB 供电)',
  cp_pheasant_s_range_1_note: '* 请勿长时间在湿度超过 90% 的环境下使用。',
  cp_pheasant_s_range_2_title_0: '外接温度探头：',
  cp_pheasant_s_range_2_title_1: '-40 ~ 125℃',
  cp_pheasant_s_wireless_desc: 'Wi-Fi 或 NB-IoT 或 LoRa',
  cp_pheasant_s_supportApp_0_name: '青萍物联',
  cp_pheasant_s_sizeWeight_0_items_0_label: '77 × 77 × 28 毫米',
  cp_pheasant_s_sizeWeight_0_items_1_label: '129 克',
  cp_pheasant_s_powerInfo_0_label: 'USB-C 接口供电\n大容量可充电锂电池',
  cp_pheasant_s_mounting: '墙面模式',
  cp_frog_display_type: '低功耗段码屏',
  cp_frog_display_size: '64.6 × 44.6 毫米',
  cp_frog_probe_desc: '外接温度探头',
  cp_frog_waterproof_desc: '主机：IP55 级防护',
  cp_frog_waterproof_desc2: '外接温度探头：IP68 级防护，可持续浸水使用',

  cp_frog_range_0_title_0: '主机温度：',
  cp_frog_range_0_title_1: '-30 ~ 60°C （使用锂铁 5 号电池）',
  cp_frog_range_0_title_2: '-10 ~ 50°C （使用普通 5 号电池）',
  cp_frog_range_0_title_3: '0 ~ 40°C （使用 USB 供电）',
  cp_frog_range_1_title_0: '主机湿度：',
  cp_frog_range_1_title_1: '0 ~ 100%RH（使用电池，无凝露环境）',
  cp_frog_range_1_title_2: '0 ~ 90%RH （使用 USB 供电，无凝露环境）',
  cp_frog_range_1_note: '* 请勿长时间在湿度超过 90% 的环境下使用。',
  cp_frog_range_2_title_0: '外接温度探头：',
  cp_frog_range_2_title_1: '-40 ~ 125℃',
  cp_frog_wireless_desc: 'Wi-Fi 或 NB-IoT 或 LoRa',
  cp_frog_supportApp_0_name: '青萍物联',
  cp_frog_sizeWeight_0_items_0_label: '主机：',
  cp_frog_sizeWeight_0_items_1_label: '87.6 × 156.8 × 33 毫米（含天线）',
  cp_frog_sizeWeight_0_items_2_label: '118 克',
  cp_frog_sizeWeight_1_items_0_label: '外接温度探头：',
  cp_frog_sizeWeight_1_items_1_label: '传感器探头：',
  cp_frog_sizeWeight_1_items_1_value: '直径 6 毫米，长度 50 毫米；',
  cp_frog_sizeWeight_1_items_2_label: '线身：',
  cp_frog_sizeWeight_1_items_2_value: '直径 3.5 毫米，长度 1500 毫米；',
  cp_frog_sizeWeight_1_items_3_label: '吸盘式固定支架：',
  cp_frog_sizeWeight_1_items_3_value: '直径 35 毫米，高 20 毫米',
  cp_frog_sizeWeight_1_items_4_label: '29 克',
  cp_frog_powerInfo_0_label: '5 号电池供电\nMicro-USB 接口供电',
  cp_frog_powerInfo_0_note: '* 可长期连接 Micro-USB 电源。不支持充电。',
  cp_frog_mounting: 'DIN 导轨固定、磁吸',
  cp_gecko_display_type: '低功耗段码屏',
  cp_gecko_display_size: '30 × 19 毫米',
  cp_gecko_range_0_title_0: '温度：-20 ~ 50℃',
  cp_gecko_wireless_desc: 'NB-IoT',
  cp_gecko_supportApp_0_name: '青萍物联',
  cp_gecko_sizeWeight_0_items_0_label: '86 × 86 × 38.5 毫米（墙外 11.5 毫米）',
  cp_gecko_sizeWeight_0_items_1_label: '126.8 克',
  cp_gecko_powerInfo_0_label: '墙壁接线盒供电',
  cp_gecko_powerInfo_1_label: '额定电压：',
  cp_gecko_powerInfo_1_value: '250V 交流电',
  cp_gecko_powerInfo_2_label: '额定电流：',
  cp_gecko_powerInfo_2_value: '最大 10A',
  cp_gecko_powerInfo_3_note: ' ',
  cp_gecko_mounting: '86 盒安装',
  cp_gecko_mountingNote: '* 86 盒是一种接线盒规格，尺寸为 86 × 86 毫米。',
  cp_magpie_display_type: '电子墨水屏',
  cp_magpie_display_size: '26 × 26 毫米',
  cp_magpie_range_0_title_0: '温度：0 ~ 50℃',
  cp_magpie_range_0_title_1: '湿度：0 ~ 99.9%RH (无凝露环境)',
  cp_magpie_range_1_note: '* 请勿长时间在湿度超过 90% 的环境下使用。',
  cp_magpie_wireless_desc: '蓝牙',
  cp_magpie_supportApp_0_name: '李吉他温湿度',
  cp_magpie_sizeWeight_0_items_0_label: '131 × 37 × 12.4 毫米',
  cp_magpie_sizeWeight_0_items_1_label: '30 克（不含电池）',
  cp_magpie_powerInfo_0_label: 'CR2032 纽扣电池供电\n',
  cp_magpie_powerInfo_1_label: '续航长达 8 个月',
  cp_magpie_powerInfo_1_note: '* 在常见室温环境下可持续使用 8 个月。实际续航时间可能依环境和电池的差异而有所不同。',
  cp_magpie_mounting: '磁吸模式',
  bluetooth_gateway_link: '青萍蓝牙网关',
  detection_text_mi: '米家：需配备米家蓝牙网关设备，如{bluetoothGatewayLink}。支持与其他米家设备联动。',
  detection_text_plus_iot: '青萍+ 和青萍物联：需配备{bluetoothGatewayLink}。',
  detection_text_iot: '通过青萍物联可进行设备管理、数据收集、 数据查询、设置警报通知等。',
  detection_text_magpie: '李吉他温湿度和青萍+：需配备{bluetoothGatewayLink}。',
  pheasant_s_no_pressure: '青萍商用温湿度计 S',
};